import type { AnalyticsEvent } from "@shared/hooks/useAnalyticsLogger/AnalyticsEvent";
import type { SearchApplyEntryPoint } from "@shared/hooks/useAnalyticsLogger/StoreAnalyticsEntryPoint";

import { FiltersContent } from "../FiltersContent/FiltersContent";

import * as styles from "./DesktopFilterContainer.styles";

interface Props {
  entryPointForLogging?: SearchApplyEntryPoint;
  eventNameForLogging?: AnalyticsEvent;
  isDrawer?: boolean;
  isCyberMondayEnabled?: boolean;
  filterTilesWithSpacing?: boolean;
}

const DesktopFilterContainer = ({
  isDrawer = false,
  isCyberMondayEnabled = false,
  entryPointForLogging,
  eventNameForLogging,
  filterTilesWithSpacing = true,
}: Props) => {
  const containerStyles = [styles.container, filterTilesWithSpacing && styles.margin];

  return (
    <div css={containerStyles}>
      <FiltersContent
        isDrawer={isDrawer}
        isCyberMondayEnabled={isCyberMondayEnabled}
        entryPointForLogging={entryPointForLogging}
        eventNameForLogging={eventNameForLogging}
      />
    </div>
  );
};

export { DesktopFilterContainer };
